var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_148_718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.94043,
    y: 0.301941,
    width: 38.583,
    height: 38.583,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_148_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3417 22.4624C12.7456 22.4624 13.0836 22.3264 13.3557 22.0543C13.6278 21.7823 13.7638 21.4468 13.7638 21.048C13.7638 20.6492 13.6278 20.3112 13.3557 20.034C13.0836 19.7568 12.7482 19.6182 12.3494 19.6182C11.9506 19.6182 11.6126 19.7568 11.3353 20.034C11.0581 20.3112 10.9195 20.6466 10.9195 21.0403C10.9195 21.4442 11.0581 21.7823 11.3353 22.0543C11.6126 22.3264 11.948 22.4624 12.3417 22.4624ZM12.3417 17.8251C12.7456 17.8251 13.0836 17.689 13.3557 17.417C13.6278 17.1449 13.7638 16.8095 13.7638 16.4107C13.7638 16.0118 13.6278 15.6738 13.3557 15.3966C13.0836 15.1194 12.7482 14.9808 12.3494 14.9808C11.9506 14.9808 11.6126 15.1194 11.3353 15.3966C11.0581 15.6738 10.9195 16.0093 10.9195 16.4029C10.9195 16.8069 11.0581 17.1449 11.3353 17.417C11.6126 17.689 11.948 17.8251 12.3417 17.8251ZM12.3417 13.1877C12.7456 13.1877 13.0836 13.0516 13.3557 12.7796C13.6278 12.5075 13.7638 12.1721 13.7638 11.7733C13.7638 11.3745 13.6278 11.0365 13.3557 10.7593C13.0836 10.4821 12.7482 10.3434 12.3494 10.3434C11.9506 10.3434 11.6126 10.4821 11.3353 10.7593C11.0581 11.0365 10.9195 11.3719 10.9195 11.7656C10.9195 12.1695 11.0581 12.5075 11.3353 12.7796C11.6126 13.0516 11.948 13.1877 12.3417 13.1877ZM17.2017 21.9523H24.6523V20.1283H17.2017V21.9523ZM17.2017 17.3149H29.4999V15.4909H17.2017V17.3149ZM17.2017 12.6776H29.4999V10.8535H17.2017V12.6776ZM4.95898 34.1238V6.63976C4.95898 6.00933 5.18783 5.46527 5.64552 5.00758C6.10321 4.54989 6.64727 4.32104 7.2777 4.32104H33.1851C33.8155 4.32104 34.3596 4.54989 34.8172 5.00758C35.2749 5.46527 35.5038 6.00933 35.5038 6.63976V26.1166C35.5038 26.7471 35.2749 27.2911 34.8172 27.7488C34.3596 28.2065 33.8155 28.4353 33.1851 28.4353H10.6475L4.95898 34.1238Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerNotes);
export default __webpack_public_path__ + "static/media/speaker_notes.914e623741f95779b423fa11a04cacaa.svg";
export { ForwardRef as ReactComponent };